import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista"
import { PopupExtraG } from "../../components/Popup/PopupExtraG";
import servAnalises from "../../services/login/servAnalises";
import { columnsAnaliseAnaliseProjeto } from "./Lista";
import styles from "./AnaliseProjetoAnalise.module.css";
import Cadastro from "../AnaliseProjeto/Cadastro";

const AnaliseProjetoAnalise = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [openAnalise, setOpenAnalise] = useState(false);
    const [recordForView, setRecordForView] = useState(null);
    const [analisesAnaliseProjeto, setAnalisesAnaliseProjeto] = useState([]);
    const [tabResultadoAnalise, setTabResultadoAnalise] = useState(false);
    const [eNovoCadastro, setENovoCadastro] = useState(false);
    const [analisesDaSolic, SetAnalisesDaSolic] = useState(false);

    const analises = useSelector((state) => state.analises);

    const onClickPesquisar = async () => {
        try {

            setIsLoading(true);

            const data = await servAnalises.ListarAnalisesAnaliseProjeto(analises.codigoAnaliseProjeto, filtro);
            
            let analiseAnaliseProjeto = data.Content;

            analiseAnaliseProjeto.map((analise) => {
                analise.id = analise.Id
            });

            setAnalisesAnaliseProjeto(analiseAnaliseProjeto);

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);

            console.log(err.Messsage);
        }
    }

    useEffect(() => {

        const recuperarAnalisesAnteriores = async () => {
            try {

                setIsLoading(true);

                const data = await servAnalises.ListarAnalisesAnaliseProjeto(analises.codigoAnaliseProjeto, "");

                let analiseAnaliseProjeto = data.Content;

                analiseAnaliseProjeto.map((analise) => {
                    analise.id = analise.Id;
                })

                setAnalisesAnaliseProjeto(analiseAnaliseProjeto);
                setTabResultadoAnalise(true);
                setENovoCadastro(false);
                SetAnalisesDaSolic(true);

                setIsLoading(false);
                
            } catch (err) {
                
                setIsLoading(false);

            }
        }

        if (analises.codigoAnaliseProjeto) {
            recuperarAnalisesAnteriores();
        } 

    }, [analises]);

    return (
        <div className={styles.analiseContainer}>
            <h2 style={{ margin: 0}}>Análises da análise de projetos</h2>
            <div className={styles.analiseFiltros}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8" }}>Data de apresentação</InputLabel>
                    <WhiteInput 
                        value={filtro} 
                        onChange={(e) => setFiltro(e.target.value)} 
                        type="date"
                        id="pesquisa-data" 
                        sx={{ width: "500px", marginRight: "10px" }}     
                    />
                </FormControl>
                <BlueHoverButton onClick={onClickPesquisar} variant="contained"  style={{ marginTop: "15px" }} >
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div>
                <Lista
                    columns={columnsAnaliseAnaliseProjeto}
                    rows={analisesAnaliseProjeto}
                    onDblClick={setOpenAnalise}
                    setSelectedData={setRecordForView}
                    hideFooter={true}
                    autoHeight={true}
                />
            </div>
            <PopupExtraG title="Análise da análise de projeto" openPopup={openAnalise} setOpenPopup={setOpenAnalise}>
                <Cadastro
                    setOpen={setOpenAnalise}
                    recordForEdit={analisesAnaliseProjeto}
                    pesquisar={onClickPesquisar}
                    novoCadastro={eNovoCadastro}
                    setEhNovoCadastro={setENovoCadastro}
                    tabResultadoAnalise={tabResultadoAnalise}
                    analisesDaSolic={analisesDaSolic}
                    recordForView={recordForView}
                />
            </PopupExtraG>
        </div>
    )
}

export { AnaliseProjetoAnalise }